import Vue from 'vue'
import Vuex from 'vuex'
import { store } from '@hll/cashier-kit'

Vue.use(Vuex)

// export default new Vuex.Store({
//   state: {
//     storedCards: []
//   },
//   mutations: {
//     setStoredCards: (state, payload) => {
//       state.storedCards = payload
//     }
//   },
//   getters: {
//     storedCards: state => {
//       return state.storedCards
//     }
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
export default new Vuex.Store(store)
